import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import HidroYPetroRules from '../../support/rules/complementos-concepto/HidroYPetroRules';
import HidroYPetroCatalogoManager from '../../../catalogs/managers/HidroYPetroCatalogoManager';

const ComplementoConceptoHidroYPetro = (props) => {
  const rules = HidroYPetroRules(props.data);

  const [catalog, setCatalog] = useState();

  useEffect(() => {
    const loadCatalog = async () => {
      const claveHYP = await HidroYPetroCatalogoManager.get('c_hyp_clave');
      const tipoPermiso = await HidroYPetroCatalogoManager.get('c_hyp_tipo_permiso');
      const subProductoHYP = await HidroYPetroCatalogoManager.get('c_hyp_sub_producto');

      const catalogo = {};
      catalogo.claveHYP = catalogSorted(claveHYP);
      catalogo.tipoPermiso = catalogSorted(tipoPermiso);
      catalogo.subProductoHYP = catalogSorted(subProductoHYP);

      setCatalog(catalogo);
    };

    loadCatalog();
  }, []);

  const catalogSorted = (values) => {
    let sorted = [];

    if (!!values) {
      sorted = _.sortBy(
        values.map((item) => {
          return {
            label: item.descripcion + ' (' + item.clave + ')',
            value: item.clave,
          };
        }),
        'label'
      );
      // Agregar opción vacía
      sorted.unshift({ label: 'Selecciona una opción', value: '' });
    }

    return sorted;
  };

  const validate = (data) => {
    const rules = HidroYPetroRules(data);
    return new Validator(data, rules);
  };

  const handleOnChange = (event) => {
    const data = {
      ...props.data,
      ...event,
      Version: '1.0',
    };

    const validator = validate(data);

    props.onChange('HidroYPetro', {
      data,
      isValid: validator.passes(),
    });
  };

  const handleOnCancel = () => {
    props.onCancel('HidroYPetro');
  };

  const data = props.data || {};

  // PER01	Expendio en estaciones de servicio de petrolíferos	PL/(N°Consecutivo)/EXP/ES/(Año)	PL/[0-9]{3,20}/EXP/ES/[0-9]{4}
  // PER02	Comercialización	H/(N°Consecutivo)/COM/(Año)	H/[0-9]{3,24}/COM/[0-9]{4}
  // PER03	Distribución por otros medios distintos a ducto	PL/(N°Consecutivo)/DIS/OM/(Año)	PL/[0-9]{3,20}/DIS/OM/[0-9]{4}
  // PER04	Expendio en estaciones de servicio multimodal de petrolíferos	PL/(N°Consecutivo)/EXP/ES/MM/(Año)	PL/[0-9]{3,17}/EXP/ES/MM/[0-9]{4}
  // PER05	Expendio en estaciones de servicio de petrolíferos	CNE/PL/(N°Consecutivo)/EXP/ES/(Año)	CNE/PL/[0-9]{3,16}/EXP/ES/[0-9]{4}
  // PER06	Comercialización	CNE/H/(N°Consecutivo)/COM/(Año)	CNE/H/[0-9]{3,20}/COM/[0-9]{4}
  // PER07	Distribución por otros medios distintos a ducto	CNE/PL/(N°Consecutivo)/DIS/OM/(Año)	CNE/PL/[0-9]{3,16}/DIS/OM/[0-9]{4}
  // PER08	Expendio en estaciones de servicio multimodal de petrolíferos	CNE/PL/(N°Consecutivo)/EXP/ES/MM/(Año)	CNE/PL/[0-9]{3,13}/EXP/ES/MM/[0-9]{4}
  // PER09	Comercialización	CNE/PL/(N°Consecutivo)/COM/(Año)	CNE/PL/[0-9]{3,19}/COM/[0-9]{4}
  // PER10	Comercialización	#[a-zA-Z0-9]	#[a-zA-Z0-9]{14}
  // PER11	Comercialización	F00.07.UH/(N°Consecutivo)/(Año)	F00\.07\.UH/[0-9]{3,20}/[0-9]{4}

  let helperTextNumeroPermiso = 'El formato del número de permiso depende del tipo de permiso seleccionado.';
  let placeholderNumeroPermiso = '';

  if (data.TipoPermiso === 'PER01') {
    placeholderNumeroPermiso = 'PL/123/EXP/ES/2024';
    helperTextNumeroPermiso = 'PL/(N°Consecutivo 3 a 20 dígitos)/EXP/ES/(Año 4 dígitos)';
  } else if (data.TipoPermiso === 'PER02') {
    placeholderNumeroPermiso = 'H/1234/COM/2024';
    helperTextNumeroPermiso = 'H/(N°Consecutivo 3 a 24 dígitos)/COM/(Año 4 dígitos)';
  } else if (data.TipoPermiso === 'PER03') {
    placeholderNumeroPermiso = 'PL/123/DIS/OM/2024';
    helperTextNumeroPermiso = 'PL/(N°Consecutivo 3 a 20 dígitos)/DIS/OM/(Año 4 dígitos)';
  } else if (data.TipoPermiso === 'PER04') {
    placeholderNumeroPermiso = 'PL/123/EXP/ES/MM/2024';
    helperTextNumeroPermiso = 'PL/(N°Consecutivo 3 a 17 dígitos)/EXP/ES/MM/(Año 4 dígitos)';
  } else if (data.TipoPermiso === 'PER05') {
    placeholderNumeroPermiso = 'CNE/PL/123/EXP/ES/2024';
    helperTextNumeroPermiso = 'CNE/PL/(N°Consecutivo 3 a 16 dígitos)/EXP/ES/(Año 4 dígitos)';
  } else if (data.TipoPermiso === 'PER06') {
    placeholderNumeroPermiso = 'CNE/H/1234/COM/2024';
    helperTextNumeroPermiso = 'CNE/H/(N°Consecutivo 3 a 20 dígitos)/COM/(Año 4 dígitos)';
  } else if (data.TipoPermiso === 'PER07') {
    placeholderNumeroPermiso = 'CNE/PL/123/DIS/OM/2024';
    helperTextNumeroPermiso = 'CNE/PL/(N°Consecutivo 3 a 16 dígitos)/DIS/OM/(Año 4 dígitos)';
  } else if (data.TipoPermiso === 'PER08') {
    placeholderNumeroPermiso = 'CNE/PL/123/EXP/ES/MM/2024';
    helperTextNumeroPermiso = 'CNE/PL/(N°Consecutivo 3 a 13 dígitos)/EXP/ES/MM/(Año 4 dígitos)';
  } else if (data.TipoPermiso === 'PER09') {
    placeholderNumeroPermiso = 'CNE/PL/123/COM/2024';
    helperTextNumeroPermiso = 'CNE/PL/(N°Consecutivo 3 a 19 dígitos)/COM/(Año 4 dígitos)';
  } else if (data.TipoPermiso === 'PER10') {
    placeholderNumeroPermiso = '#ABC1234567890';
    helperTextNumeroPermiso = '#(14 caracteres alfanuméricos)';
  } else if (data.TipoPermiso === 'PER11') {
    placeholderNumeroPermiso = 'F00.07.UH/123/2024';
    helperTextNumeroPermiso = 'F00.07.UH/(N°Consecutivo 3 a 20 dígitos)/(Año 4 dígitos)';
  }

  return (
    <>
      <div className="pb-4 text-right">
        <strong className="text-black text-upper">Complemento HidroYPetro</strong>
      </div>

      <Row>
        <Col
          sm
          md={6}
        >
          <FormControl
            type="select"
            label="Tipo permiso"
            name="TipoPermiso"
            placeholder=""
            help=""
            options={catalog?.tipoPermiso}
            rules={rules.TipoPermiso}
            value={data.TipoPermiso}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          sm
          md={6}
        >
          <FormControl
            type="text"
            label="Numero permiso"
            name="NumeroPermiso"
            casing={'upper'}
            placeholder={placeholderNumeroPermiso}
            help={helperTextNumeroPermiso}
            minLength="15"
            maxLength="35"
            rules={rules.NumeroPermiso}
            value={data.NumeroPermiso}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          sm
          md={6}
        >
          <FormControl
            type="select"
            label="Clave HYP"
            name="ClaveHYP"
            placeholder=""
            help=""
            options={catalog?.claveHYP}
            rules={rules.ClaveHYP}
            value={data.ClaveHYP}
            onChange={handleOnChange}
          />
        </Col>

        <Col
          sm
          md={6}
        >
          <FormControl
            type="select"
            label="Sub Producto HYP"
            name="SubProductoHYP"
            placeholder=""
            help=""
            options={catalog?.subProductoHYP}
            rules={rules.SubProductoHYP}
            value={data.SubProductoHYP}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <Row className="pb-3 text-right">
        <Col>
          <Button
            variant="secondary"
            className="mr-3"
            onClick={handleOnCancel}
          >
            Cancelar
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ComplementoConceptoHidroYPetro;
